<template>
  <div class="dock-page">
    <!-- 顶部横幅部分 -->
    <div class="section-banner">
      <div class="content">
        <h1>产业洞察和分析</h1>
        <p>我们致力于为用户提供合适的产业资源解决用户寻找所需产业资源面临的效率挑战，助力用户获得成功</p>
        <div class="actions">
          <el-button class="btn-yellow" type="primary" @click="goToUserExperience">立即体验</el-button>
          <el-button class="btn-dark" type="primary">&gt;</el-button>
        </div>
      </div>
    </div>

    <!-- 主标题部分 -->
    <div class="main-title">
      <h2>资源对接</h2>
      <p>精准资源对接，资金、技术、人才、资源，助推产业资源整合，促进资源高效配置。</p>
    </div>

    <!-- 服务卡片部分 -->
    <div class="service-cards">
      <!-- 卡片1 -->
      <div class="service-card">
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/dock-bg2.png" alt="信任链穿透算法">
        </div>
        <div class="card-content">
          <h2>信任链穿透算法</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>基于区块链技术，构建可信赖的资源信息传递与验证机制，打破信息孤岛，确保资源对接的真实性和可靠性。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>通过严格的身份认证和信息审核，为资源提供方与需求方建立可信连接。</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 卡片2 -->
      <div class="service-card">
        <div class="card-content">
          <h2>风险担保池机制</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>创新风险管控体系，建立多层次风险防范机制，保障资源对接全流程安全可靠。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>整合多方资源，打造共享风险池，为企业合作提供全方位保障，降低交易风险，增强合作信心。</p>
            </div>
          </div>
        </div>
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/dock-bg3.png" alt="风险担保池机制">
        </div>
      </div>

      <!-- 卡片3 -->
      <div class="service-card">
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/dock-bg4.png" alt="跨周期资源包">
        </div>
        <div class="card-content">
          <h2>跨周期资源包</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>打破传统资源对接的时间局限，提供跨周期、全生命周期的资源整合服务，满足企业长期发展需求。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>通过智能算法，预测企业未来资源需求，提前规划资源配置，实现资源利用的最大化和成本的最小化。</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 卡片4 -->
      <div class="service-card">
        <div class="card-content">
          <h2>资源效益区块链</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>应用区块链技术，构建透明、可追溯的资源价值流转体系，确保资源对接的公平公正，最大化资源效益。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>通过智能合约自动执行资源交换和价值分配，降低中间环节成本，提高资源对接效率。</p>
            </div>
          </div>
        </div>
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/dock-bg5.png" alt="资源效益区块链">
        </div>
      </div>
    </div>

    <!-- 服务咨询部分 -->
    <div class="section-contact">
      <div class="contact-content">
        <h2>开启专属服务<br>获取更大价值</h2>
        <el-form class="contact-form" :model="contactForm" :rules="contactRules" ref="contactForm">
          <el-input v-model="contactForm.name" placeholder="您的姓名"></el-input>
          <el-input v-model="contactForm.mobile" placeholder="手机号码"></el-input>
          <div class="actions">
            <el-button class="btn-yellow" type="primary" @click="submitContactForm">Services</el-button>
            <el-button class="btn-dark" type="primary">&gt;</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { saveUserRequirementApi } from '@/api/index';

export default {
  name: 'DockPage',
  data() {
    return {
      contactForm: {
        name: '',
        mobile: '',
        companyName: '测试公司名称',
        demandType: '3' // 按照要求设置为3
      },
      contactRules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    goToUserExperience() {
      window.open('http://user.yishangji.com.cn/', '_blank');
    },

    submitContactForm() {
      // 判断姓名和手机号是否为空
      if (!this.contactForm.name || this.contactForm.name.trim() === '') {
        this.$message.error('请输入您的姓名');
        return;
      }
      if (!this.contactForm.mobile || this.contactForm.mobile.trim() === '') {
        this.$message.error('请输入手机号码');
        return;
      }
      
      this.$refs.contactForm.validate(valid => {
        if (valid) {
          saveUserRequirementApi(this.contactForm).then(res => {
            this.$message.success('提交成功');
            this.contactForm.name = '';
            this.contactForm.mobile = '';
          }).catch(err => {
            this.$message.error('提交失败，请稍后重试');
            console.error(err);
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.dock-page {
  width: 100%;
  background-color: #fff;
  color: #333;
}

// 顶部横幅
.section-banner {
  height: 1080px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/dock-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  color: #fff;

  .content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 345px;

    h1 {
      font-weight: bold;
      font-size: 78px;
      line-height: 92px;
      margin-bottom: 30px;
    }

    p {
      font-size: 17px;
      font-weight: bold;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      line-height: 25px;
      margin-bottom: 70px;
      max-width: 700px;
    }

    .actions {
      display: flex;

      .btn-yellow {
        background-color: #ffc107;
        border-color: #ffc107;
        color: #0F0FB1;
        width: 150px;
        height: 50px;
        font-size: 20px;
        font-weight: bold;
        line-height: 22px;
      }
      
      .btn-dark {
        background-color: #002366;
        border-color: #002366;
        color: #fff;
        width: 50px;
        height: 50px;
        margin-left: -5px;
      }
    }
  }
}

// 主标题部分
.main-title {
  width: 1200px;
  margin: 80px auto 40px;
  text-align: center;

  h2 {
    font-weight: bold;
    font-size: 48px;
    color: #19456B;
    line-height: 60px;
    margin-bottom: 20px;
  }

  p {
    font-size: 17px;
    color: #382933;
    line-height: 25px;
    max-width: 800px;
    margin: 0 auto;
  }
}

// 服务卡片区域
.service-cards {
  width: 1200px;
  margin: 60px auto;
}

.service-card {
  display: flex;
  justify-content: space-between;
  margin-bottom: 80px;

  .card-image {
    width: 45%;
    img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  .card-content {
    width: 45%;
    padding: 20px 0;

    h2 {
      font-weight: bold;
      font-size: 32px;
      color: #19456B;
      line-height: 42px;
      margin-bottom: 30px;
    }

    .feature {
      display: flex;
      margin-bottom: 20px;

      .feature-icon {
        color: #4CAF50;
        font-size: 20px;
        margin-right: 10px;
        margin-top: 2px;
      }

      .feature-text {
        p {
          font-size: 17px;
          color: #382933;
          line-height: 25px;
          margin: 0;
        }
      }
    }
  }
}

// 服务咨询部分
.section-contact {
  margin: 0 auto 100px;
  width: 1200px;
  height: 340px;
  box-sizing: border-box;
  padding: 40px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/bg-contact.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;

  .contact-content {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    h2 {
      font-weight: bold;
      font-size: 48px;
      color: #FFFFFF;
      line-height: 52px;
    }

    .contact-form {
      display: block;

      .el-input {
        width: 350px;
        display: block;
        margin-bottom: 25px;

        ::v-deep .el-input__inner {
          background-color: transparent;
          border: none;
          border-bottom: 2px solid rgba(255, 255, 255, 0.5);
          border-radius: 0;
          padding-left: 0;
          height: 50px;
          font-size: 24px;
          color: #FFFFFF;
          line-height: 24px;

          &:focus {
            border-bottom-color: #fff;
          }

          &::placeholder {
            color: #ccc;
            font-size: 24px;
          }
        }
      }

      .actions {
        display: flex;

        .btn-yellow {
          background-color: #ffc107;
          border-color: #ffc107;
          color: #0F0FB1;
          width: 150px;
          height: 50px;
          font-size: 20px;
          font-weight: bold;
          line-height: 22px;
        }

        .btn-dark {
          background-color: #002366;
          border-color: #002366;
          color: #fff;
          width: 50px;
          height: 50px;
          margin-left: -5px;
        }
      }
    }
  }
}
</style>
